function toggleAdditionalFields(toggle) {
  if(!toggle) return;
  document.querySelectorAll('[data-additional-fields-for]').forEach(el => {
    const fieldsForArr = el.dataset.additionalFieldsFor?.split(',');
    el.classList.toggle('hidden', !fieldsForArr || !fieldsForArr.includes(toggle));
    el.querySelectorAll('input, select, textarea').forEach(input => {
      input.disabled = !fieldsForArr || !fieldsForArr.includes(toggle);
    });
  });
}

window.addEventListener('DOMContentLoaded', (event) => {
  document.querySelectorAll('.field__radios input').forEach(radio => {
    radio.addEventListener('change', (e) => {
      toggleAdditionalFields(radio.dataset.toggles);
    });
  });
});